<template>
  <div class="pkg" @click="$emit('select', item)">
    <div v-if="item.abbreviation" class="top">
      {{ item.abbreviation }}
    </div>
    <div class="icon-desc"></div>
    <div class="center">
      <div class="pkg-title">{{ item.title }}</div>
      <div class="btn" @click.stop="$emit('onBuy', item)">购买</div>
    </div>
    <p v-if="item.subtitle" class="detail">{{ item.subtitle }}</p>
    <div class="bottom">
      <span class="num">
        <p v-if="+item.quota > 0">
          剩余 <span>{{ item.quota }}</span> 个名额
        </p>
      </span>
      <div class="price-wrap">
        <span class="price"> 原价：¥{{ item.origin_price }} </span>
        <span class="lower-price"> <span>¥</span>{{ item.price }} </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      defualt: () => {}
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions';

.pkg {
  position: relative;
  width: 600px;
  height: 240px;
  padding: 34px 30px 0;
  background: linear-gradient(
    180deg,
    rgba(255, 247, 245, 0.4) 0%,
    rgba(255, 246, 245, 0.4) 0%,
    rgba(255, 247, 246, 0.4) 0%,
    rgba(255, 245, 229, 0.4) 0%,
    rgba(255, 233, 209, 0.4) 100%
  );
  border-radius: 20px;
  box-sizing: border-box;
  border: 2px solid rgba(255, 221, 186, 0.4);
  .top {
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    padding: 0 19px 0 18px;
    height: 28px;
    border-radius: 20px 0px 20px 0px;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 28px;
    background: #fff1e2;
    color: #ff745b;
  }
  .center {
    display: flex;
    justify-content: space-between;
    .pkg-title {
      min-width: 394px;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 700;
      color: rgba(33, 37, 45, 1);
      line-height: 44px;
      @include limitLine(2);
      margin-right: 30px;
    }
    .btn {
      flex-shrink: 0;
      width: pxToRem(105);
      height: pxToRem(52);
      background: linear-gradient(270deg, #fecec6 0%, #fc7052 100%);
      border-radius: pxToRem(27);
      text-align: center;
      font-size: pxToRem(26);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: pxToRem(52);
    }
  }
  p.detail {
    width: calc(100% - 1.2rem);
    height: 36px;
    opacity: 1;
    font-size: 24px;
    line-height: 36px;
    color: rgba(108, 121, 140, 1);
    @include limitLine(1);
  }
  .bottom {
    width: 530px;
    position: absolute;
    bottom: 20px;
    right: 30px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .price-wrap {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      .price {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #9da3ac;
        margin-right: 16px;
        text-decoration: line-through;
        line-height: 24px;
      }

      .lower-price {
        font-size: 42px;
        font-family: DharmaTypeBebasKai;
        color: #ffa202;
        font-weight: 700;
        line-height: 30px;
        span {
          font-size: 30px;
          line-height: 30px;
        }
      }
    }
    .num {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #9da3ac;
      line-height: 24px;
      span {
        font-size: 22px;
        color: rgba(255, 116, 91, 1);
        margin: 0 3px;
      }
    }
  }
  .icon-desc {
    position: absolute;
    right: 10px;
    top: 5px;
    width: 25px;
    height: 25px;
    background: url('../../../../images/platform/homepage/icon-qingsu-desc.png')
      no-repeat center/100%;
  }
}
</style>
